import { get, post } from '@/service/request';

const url = 'api/twid';

/**
 get(url, params, options)
 post(url, data, options)

 // options default值
 options: {
     auth: false,  打api是否需要權限
     dumplicateRequest: true, 是否允許在還沒收到response，可以重複打著這隻API
     needNotify: true,  收到error時，是否要出現通知
     needLoading: true, 發request時，是否需要loading
     needDelay: true, 收到發response時，是否需要延遲0.5秒回傳
     contentType: 'application/json', 設置request header 的 contentType
 }
 */

// 0.登入
// export function postAuthSSO(data) {
//    return post('auth/sso', { ...data }, { needNotify: false });
// }

/**
 * 2-1.取得TOKEN基本資料
 */
// export function getCustomerInfo() {
//     return get('customerInfo');
// }

/**
 * 2-2.檢查基本資料正確性
 * 因為是顯示錯誤訊息在input底，所以不需要notify
 */
// export function validateCustomerInfo(data) {
//     return post('customerInfo/validate', data, {
//         needNotify: false,
//         needLoading: false,
//     });
// }

/**
 * 3-1.取得客戶留存於有效保單的行動電話及投資風險屬性問卷主檔留存之行動電話
 */
export function getMobileList() {
    return get(`${url}/mobileList`);
}

/**
 * 3-2.客戶選擇要發送OTP的行動電話
 */
export function submitOTPMobile(mobileSelect) {
    return post(`${url}/submitOTPMobile`, { mobileSelect });
}

/**
 * 5-1.取得TWID台網認證通行證
 * 若不通過要去routeName.FAILURE_MID
 * 通過後要判斷是否有問卷存在 是 -> 屬性結果; 否 -> 填問卷
 */
export function getTokenTWID(data) {
    return post('twid/getToken', data);
}
/**
 * 5-3.取得TWID台網認證通結果
 */
export function getTWIDResult() {
    return get(`${url}/result`);
}
/**
 * 6.送出門號申辦人關係及說明
 */
// export function updateMIDData(data) {
//     return post('updateMIDData', data);
// }
/**
 * 6-1.取得與門號申辦人關係清單
 */
// export function getRelationList() {
//     return post('relationList');
// }
/**
 * 7 發出OTP認證碼
 */
// export function sendOTP(data) {
//     return post('otp/send', data, { needNotify: false });
// }
/**
 * 8 驗證OTP認證碼
 */
// export function submitOTP(data) {
//     return post('otp/submit', data, { needNotify: false });
// }
/**
 * 9 取得投資屬性資料
 */
// export function getInvestmentType(option) {
//     return get('getInvestmentType', null, option);
// }
/**
 * 10 取得投資風險屬性問卷題目
 */
// export function getQuestionSetting() {
//     return get('getQuestionSetting');
// }
/**
 * 11.輸入投資風險屬性問卷答項，並取得投資屬性結果
 */
// export function insertQuestionData(data) {
//     return post('insertQuestionData', data);
// }
/**
 * 12.輸入投資風險屬性問卷編號，下載投資風險屬性問卷
 */
// export function downloadPDF() {
//     window.open(import.meta.env.VITE_BASE_URL + '/api/downloadPDF', '_blank');
//     return Promise.resolve(true);
// }
/**
 * 14.輸入投資風險屬性問卷編號及email，寄送投資風險屬性問卷
 */
// export function sendPDF(data) {
//     return post('sendPDF', data, { needNotify: false });
// }

// 案件受理完成後繼續選擇其他保單
export function postInitContinue(data) {
    return post(`${url}/initContinue`, data);
}
